import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const renderIcon = (iconType) => {
    const iconProps = { width: "35", height: "35", fill: "#4CAF50" };
    
    switch(iconType) {
      case 'comparison':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M11,2V22C5.9,21.5 2,17.2 2,12C2,6.8 5.9,2.5 11,2M13,2V22C18.1,21.5 22,17.2 22,12C22,6.8 18.1,2.5 13,2M17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12Z"/>
          </svg>
        );
      case 'switch':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M17,7H22V9H19V11H22V13H17V15L13,11L17,7M7,17H2V15H5V13H2V11H7V9L11,13L7,17Z"/>
          </svg>
        );
      case 'audit':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
          </svg>
        );
      case 'promotion':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const services = [
    {
      title: t('services.card1.title'),
      description: t('services.card1.description'),
      cta: t('services.card1.cta'),
      icon: "comparison",
      color: "#4CAF50"
    },
    {
      title: t('services.card2.title'),
      description: t('services.card2.description'),
      cta: t('services.card2.cta'),
      icon: "switch",
      color: "#4CAF50"
    },
    {
      title: t('services.card3.title'),
      description: t('services.card3.description'),
      cta: t('services.card3.cta'),
      icon: "audit",
      color: "#FF6B35"
    },
    {
      title: t('services.card4.title'),
      description: t('services.card4.description'),
      cta: t('services.card4.cta'),
      icon: "promotion",
      color: "#9C27B0"
    }
  ];

  return (
    <section className="services section-animate" id="services" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('services.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('services.subtitle')}
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card stagger-item card-premium focus-premium" style={{'--accent-color': service.color}} tabIndex="0">
              <div className="service-icon">
                {renderIcon(service.icon)}
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <a href="#contact" className="btn btn-secondary btn-ripple focus-premium service-cta">
                  {service.cta}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 